import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from 'axios';

import { setupAxiosInterceptors } from '@src/Common/Http/axiosInterceptors';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Setup global axios interceptors for error handling
 */
setupAxiosInterceptors();

try {
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,
        cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
        forceTLS: true,
    });
} catch (e) {
    // Pusher is not setup
    console.warn('Pusher is not setup');
}
